export default {
    // 测试
    listButton: 'Button',
    // ment
    HomeOutlined: 'Mission',
    FreeAdoptionOutlined: 'FreeAdoption',
    ShopOutlined: 'About',
    FileDoneOutlined: 'Case',
    GithubOutlined: 'Knowledge',
    DollarOutlined: 'Subsidize',
    MessageOutlined: 'Booking',
};